export const MAX_TOTAL_NEEDED = 999;

const textDraftNeutralColor = 'text-requirement-draft-neutral';
const textDraftSuccessColor = 'text-requirement-draft-success-600';
const textDraftWarningColor = 'text-requirement-draft-warning-700';

const textNormalNeutralColor = 'text-requirement-neutral-90';
const textNormalSuccessColor = 'text-requirement-success-600';
const textNormalWarningColor = 'text-requirement-warning-700';

const borderDraftNeutralColor = 'border-requirement-draft-neutral-50';
const borderDraftSuccessColor = 'border-requirement-draft-success-50';
const borderDraftWarningColor = 'border-requirement-draft-warning-50';

const borderNormalNeutralColor = 'border-requirement-neutral';
const borderNormalSuccessColor = 'border-requirement-success-82';
const borderNormalWarningColor = 'border-requirement-warning-82';

const bgDraftNeutralColor = 'bg-requirement-draft-neutral-50';
const bgDraftSuccessColor = 'bg-requirement-draft-success-50';
const bgDraftWarningColor = 'bg-requirement-draft-warning-50';

const bgNormalNeutralColor = 'bg-requirement-neutral';
const bgNormalSuccessColor = 'bg-requirement-success-82';
const bgNormalWarningColor = 'bg-requirement-warning-82';

export const availableColors = {
  text: {
    draft: {
      neutral: textDraftNeutralColor,
      success: textDraftSuccessColor,
      warning: textDraftWarningColor,
    },
    normal: {
      neutral: textNormalNeutralColor,
      success: textNormalSuccessColor,
      warning: textNormalWarningColor,
    },
  },
  border: {
    draft: {
      neutral: borderDraftNeutralColor,
      success: borderDraftSuccessColor,
      warning: borderDraftWarningColor,
    },
    normal: {
      neutral: borderNormalNeutralColor,
      success: borderNormalSuccessColor,
      warning: borderNormalWarningColor,
    },
  },
  bg: {
    draft: {
      neutral: bgDraftNeutralColor,
      success: bgDraftSuccessColor,
      warning: bgDraftWarningColor,
    },
    normal: {
      neutral: bgNormalNeutralColor,
      success: bgNormalSuccessColor,
      warning: bgNormalWarningColor,
    },
  },
};
